<script setup lang="ts">
const { t, tm, rt } = useI18n()

type Cat = { name: string; count: string; icon: string; tone: string }
const cats = computed(() =>
  (tm('mock.catalog.categories') as any[]).map((c) => ({
    name:  rt(c.name),
    count: rt(c.count),
    icon:  rt(c.icon),
    tone:  rt(c.tone),
  })) as Cat[],
)
</script>

<template>
  <div class="app-screen" style="padding-bottom: 0;">
    <AppScreensStatusBar :time="t('mock.statusTime')" />

    <!-- Top bar: back arrow, gradient route pill, cart, gear -->
    <div class="app-bar" style="gap: 6px;">
      <div class="app-bar__back" style="color: var(--app-cyan);">‹</div>
      <div style="flex-direction: column; display: flex; line-height: 1.05; font-size: 9.5px;">
        <span style="color: var(--app-cyan); font-weight: 700;">{{ t('mock.catalog.back') }}</span>
        <span style="color: var(--app-text-dim); font-size: 8.5px;">{{ t('mock.catalog.backSub') }}</span>
      </div>
      <span class="app-route-pill" style="margin: 0 6px 0 4px;">✈ {{ t('mock.catalog.route') }} ✈</span>
      <span class="app-bar__action">🛒</span>
      <span class="app-bar__action">⚙</span>
    </div>

    <div style="font-size: 9.5px; color: var(--app-text-dim); margin: -2px 0 8px 4px;">
      {{ t('mock.catalog.rate') }}
    </div>

    <!-- Category grid -->
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
      <div
        v-for="(c, i) in cats" :key="i"
        class="app-cat-tile"
        :class="`app-cat-tile--${c.tone}`"
      >
        <div class="app-cat-tile__icon">{{ c.icon }}</div>
        <div class="app-cat-tile__name">{{ c.name }}</div>
        <div class="app-cat-tile__count">{{ c.count }}</div>
      </div>
    </div>

    <!-- Floating action stack (cart + search) -->
    <div class="app-fab-stack">
      <div class="app-fab app-fab--cyan">🔍</div>
      <div class="app-fab app-fab--green">🛒</div>
    </div>
  </div>
</template>
